import { isTabURL } from '@/constants/urls';
import attachmentsApi from '../attachments/sagas/api';
import requestCohortsApi from '../cohorts/sagas/api';
import requestDatasetsApi from '../datasets/sagas/api';
import markdownApi from '../markdown/sagas/api';
import markdownToasts from '../markdown/sagas/toasts';
import api from './api';
import toasts from './toasts';
import workspacesApi from '../workspaces/sagas/api';
import subscriptionsApi from '../subscriptions/sagas/api';
import layout from './layout';
import requestFrameMessages from './frames';
import taskSagas from '../tasks/sagas';

export default [
  api(),
  attachmentsApi(),
  requestCohortsApi(),
  requestDatasetsApi(),
  markdownApi(),
  markdownToasts(),
  layout(),
  toasts(),
  workspacesApi(),
  subscriptionsApi(),
  ...(isTabURL() ? [requestFrameMessages()] : []),
  ...taskSagas,
];
